/* src/app/shared/components/confidence-gauge/confidence-gauge.component.scss */
.gauge-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
.gauge-container.compact .gauge-value-wrapper {
  font-size: 0.73325rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9025rem;
  margin-bottom: -1rem;
  column-gap: 0.5rem;
}
.gauge-container.compact .gauge-value-wrapper sup {
  display: none !important;
}
.gauge-container.compact .gauge-labels {
  font-size: 0.7rem;
  margin-bottom: -0.75rem;
}
.gauge-container.compact .gauge-labels .gauge-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.gauge-container.compact .gauge-values {
  font-size: 0.5rem;
}
.gauge-container.compact .gauge-wrapper {
  border-radius: 0;
  height: 0.84606rem;
}
.gauge-container.compact .gauge-wrapper .gauge-progress::after {
  width: 0.21469rem;
  height: 165%;
  top: -32%;
}
.gauge-container.compact .gauge-ranges .range .label {
  font-size: 0.7rem;
}
.gauge-container .gauge-value-wrapper {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-start;
  justify-content: center;
  column-gap: 2.31rem;
  font-size: 1.49313rem;
  font-weight: 400;
  line-height: 2.5rem;
}
.gauge-container .gauge-value-wrapper.overlap {
  margin-bottom: -2.25rem;
}
.gauge-container .gauge-value-wrapper .value sup {
  display: inline-block;
  position: relative;
  top: -0.25em;
  right: -0.1em;
}
.gauge-container .gauge-value-wrapper .value sup a {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  width: 0.8125rem;
  height: 0.8125rem;
  border: solid thin black;
  border-radius: 50%;
  color: black;
  text-decoration: none;
}
.gauge-container .gauge-value-wrapper .value sup:hover a {
  color: #0A8080;
  border-color: #0A8080;
}
.gauge-container .gauge-labels,
.gauge-container .gauge-values {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-between;
  color: #121212;
  font-size: 0.7465rem;
  font-weight: 500;
  line-height: 1.11975rem;
}
.gauge-container .gauge-labels .gauge-label,
.gauge-container .gauge-values .gauge-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0.75rem 0;
}
.gauge-container .gauge-ranges {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-between;
  margin-top: 0.7465rem;
}
.gauge-container .gauge-ranges .range {
  position: relative;
  height: 1px;
  background-color: black;
  width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-between;
  margin-bottom: 2.5rem;
}
.gauge-container .gauge-ranges .range::before,
.gauge-container .gauge-ranges .range::after {
  content: "";
  position: absolute;
  width: 1px;
  height: 1rem;
  background-color: black;
  top: 50%;
  transform: translateY(-50%);
}
.gauge-container .gauge-ranges .range::before {
  left: 0;
}
.gauge-container .gauge-ranges .range::after {
  right: 0;
}
.gauge-container .gauge-ranges .range .label {
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1;
  padding: 0 0.25rem;
  margin-top: 2.5rem;
  text-align: center;
}
@media screen and (min-width: 48rem) {
  .gauge-container .gauge-ranges .range .label {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.gauge-wrapper {
  display: block;
  width: 100%;
  height: 1.16644rem;
  border-radius: 0.46656rem;
  background:
    linear-gradient(
      90deg,
      #F66E6E 0%,
      #F6AC68 25%,
      #F1D367 49.48%,
      #E1F46D 72.4%,
      #97F26C 100%);
  box-shadow: 0 2.98601px 8.95802px -2.23951px rgba(0, 0, 0, 0.05), 0 1.493px 3.73251px 0px rgba(0, 0, 0, 0.14);
  position: relative;
}
.gauge-wrapper .gauge-progress {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: var(--gauge-width);
  height: 100%;
  transition: width 1.5s cubic-bezier(0.68, -0.55, 0.27, 1.25);
}
.gauge-wrapper .gauge-progress::after {
  content: "";
  display: block;
  width: 1.25975rem;
  height: 2.33281rem;
  border-radius: 0.46656rem;
  border: 1.493px solid #757583;
  background: #4A4A4C;
  box-shadow: 0 2.98601px 8.95802px -2.23951px rgba(0, 0, 0, 0.05), 0px 1.493px 3.73251px 0px rgba(0, 0, 0, 0.14);
  position: absolute;
  top: -50%;
  right: -0.629875rem;
}
:host(.confidence-gauge) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=confidence-gauge.component.css.map */
